exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#grid{position:relative;width:2001px;height:2001px;display:block;background-image:linear-gradient(90deg,rgba(0,0,0,.15) 1px,transparent 0),linear-gradient(180deg,rgba(0,0,0,.15) 1px,transparent 0)}.grid-element-preview{position:absolute;width:50px;height:50px;background-color:rgba(255,0,0,.3);z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c82d5cb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid/Grid.vue
// module id = 18
// module chunks = 0